import PropTypes from "prop-types";
import React from "react";

export const NewFileNameTextComponent = ({message, originalFileName, defaultValue, onChange}) => {
    return <div>
        <h5>{message}</h5>
        <label className={"change-file-name"} data-testid={"original-fileName"}>Original File Name: {originalFileName}</label>
        <label className={"change-file-name"} data-testid={"new-fileName"}>New File Name:</label>
        <input
            id={"new_file_name"}
            data-testid={"new_file_name"}
            className={"change-file-name"}
            type={"text"}
            defaultValue={defaultValue}
            onChange={onChange}
        />
    </div>;
}

NewFileNameTextComponent.propTypes = {
    message: PropTypes.string,
    originalFileName: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func
};